import * as React from "react";
import { forwardRef } from "react";
const SvgIllustrationReport = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 101, height: 101, fill: "none", viewBox: "0 0 101 101", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 2, d: "M65.5 72v18H14V14h71v57H65.5v1ZM65.75 90.313l19.5-19" }), /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeWidth: 2, d: "M28 28h43M28 37h43M28 46h43M28 55h43" }));
const ForwardRef = forwardRef(SvgIllustrationReport);
export { ForwardRef as ReactComponent };
